import { Layer } from "react-map-gl/maplibre";
import { useLayers, useMapLabels } from "../state";
import { LABEL_MINZOOM } from "./controls/LabelSwitchControl";

// Perceellagen die de globale kaart en de werkruimtekaart delen. Beide zetten
// hun perceellagen vóór deze laag van de basisstijl, zodat straatnamen boven
// een luchtfoto blijven; de kaartlagen van LayersControl komen vóór "parcel",
// en dus onder de perceellijnen.
export const PARCEL_BEFORE_ID = "waterway_line_label"; //"label-address-housenumber"

// Op een luchtfoto is het groen van de perceellijn onleesbaar.
export const ParcelLine = ({ ...props }) => {
  const aerial = useLayers((s) => s.backgroundId !== "default");
  return (
    <Layer
      id="parcelLine"
      beforeId={PARCEL_BEFORE_ID}
      type="line"
      paint={{
        "line-color": aerial ? "rgb(239, 201, 2)" : "rgb(7, 119, 53)",
        "line-width": ["interpolate", ["linear"], ["zoom"], 10, 0.2, 18, 1.5],
      }}
      {...props}
    />
  );
};

const labelPaint = {
  "text-color": "#666",
  "text-halo-blur": 1,
  "text-halo-color": "rgba(255,255,255,0.75)",
  "text-halo-width": 1,
};
const labelTextSize = ["interpolate", ["linear"], ["zoom"], 10, 4, 20, 14];
// Huisnummers staan ~3x zo dicht als perceellabels (naaste buur mediaan 3 m
// tegen 8 m in een z14-tegel van Amersfoort) en botsen dus veel eerder weg.
// Kleiner op lage zoom en zonder padding: zichtbaar ~een zoomniveau eerder.
const houseNumberTextSize = ["interpolate", ["linear"], ["zoom"], 15, 7, 18, 10, 20, 13];

// Kadastrale aanduidingen óf huisnummers, geschakeld via de
// LabelSwitchControl (rechtsonder). key={mode} forceert een remount:
// react-map-gl kan source-layer niet in-place wijzigen.
export const ParcelLabels = ({ ...props }) => {
  // NB: net als ParcelLine de door <Source> geïnjecteerde `source`-prop
  // doorgeven — cloneElement bereikt alleen directe children
  const mode = useMapLabels((s) => s.mode);
  if (mode === "housenr")
    return (
      <Layer
        key="housenr"
        id="parcelLabels"
        type="symbol"
        source-layer="housenr"
        layout={{
          "text-field": "{number}",
          "text-font": ["Noto Sans Regular"],
          // @ts-ignore
          "text-size": houseNumberTextSize,
          "text-padding": 0,
        }}
        minzoom={LABEL_MINZOOM}
        paint={labelPaint}
        {...props}
      />
    );
  return (
    <Layer
      key="cadastre"
      id="parcelLabels"
      type="symbol"
      source-layer="label"
      layout={{
        "text-rotation-alignment": "map",
        "text-anchor": "top",
        // De tekst groeit pas mee als er ruimte is: labels die elkaar raken
        // laat maplibre weg, en het volle id ("AMF00 A 8561", ~85 px) op 17,5
        // liet in bebouwd gebied bijna alle labels verdwijnen tot ~zoom 20.
        // Nummer ("8561") → sectie + nummer ("A 8561") → volledig id.
        "text-field": [
          "step",
          ["zoom"],
          ["get", "short_name"],
          18,
          ["slice", ["get", "id"], ["+", ["index-of", " ", ["get", "id"]], 1]],
          19.5,
          ["get", "id"],
        ],
        "text-font": ["Noto Sans Regular"],
        // @ts-ignore
        "text-size": labelTextSize,
      }}
      minzoom={LABEL_MINZOOM}
      paint={labelPaint}
      {...props}
    />
  );
};
